import styled from "styled-components";

const Style = styled.div`
  gap: 48px;

  .cont {
    display: flex;
    flex-direction: column;
    height: 387px;
    gap: var(--size-lg);

    .image-cont {
      border-radius: 8px;
      flex: 1;
      overflow: hidden;
      display: flex;

      .img {
        flex: 1;
        background-size: cover !important;
        background-repeat: no-repeat !important;
        background-position: center !important;

        &.empty {
          background-size: 100% 100% !important;
        }
      }
    }

    h4 {
      font-weight: 600;
      margin-bottom: 0px;
      font-size: var(--font-size-lg);
      color: var(--base-gray-90);
    }

    p {
      margin-bottom: 0px;
      font-size: 14px;
      color: var(--base-gray-90);
      overflow-y: auto;
    }

    .divider {
      border-bottom: 1px solid var(--border-color);
    }

    .icons-rows {
      display: flex;
      flex-direction: column;
      gap: 14px;

      .item-row {
        display: flex;

        .item {
          display: flex;
          flex: 1;
          gap: 12px;

          span {
            font-weight: 500;
            font-size: 14px;
            color: var(--base-gray-90);
          }
        }
      }
    }
  }
`;

export default Style;
